<template>
  <v-card rounded="xl" outlined class="h-100">
    <v-img :src="product.imageUrl || fallbackImg" height="120" contain />
    <v-card-text class="py-2">
      <div class="text-body-2 font-weight-medium line-clamp-2">
        {{ product.name }}
      </div>

      <div class="d-flex align-center justify-space-between mt-1">
        <div class="font-weight-bold">{{ money(product.price) }}</div>

        <div v-if="qty === 0">
          <v-btn x-small color="primary" @click="$emit('add')">Add</v-btn>
        </div>

        <div v-else class="d-flex align-center">
          <v-btn icon x-small @click="$emit('dec')"><v-icon small>mdi-minus</v-icon></v-btn>
          <div style="min-width:22px;text-align:center;">{{ qty }}</div>
          <v-btn icon x-small @click="$emit('inc')"><v-icon small>mdi-plus</v-icon></v-btn>
        </div>
      </div>

      <div class="text-caption grey--text mt-1" v-if="product.Brand && product.Brand.name">
        {{ product.Brand.name }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "RemoteStoreProductCard",
  props: {
    product: { type: Object, required: true },
    qty: { type: Number, default: 0 },
  },
  data() {
    return { fallbackImg: "https://via.placeholder.com/300x200?text=No+Image" };
  },
  methods: {
    money(v) {
      const n = Number(v || 0);
      return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
    },
  },
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>